// PreviewTester/components/Tour/TourContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import { isTourCompleted, markTourCompleted } from '../PreviewTester/utils/tourStorage';

const TourContext = createContext();

export const useTour = () => {
  const context = useContext(TourContext);
  if (!context) {
    throw new Error('useTour must be used within a TourProvider');
  }
  return context;
};

export const TourProvider = ({ children }) => {
  const [isActive, setIsActive] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [isCompleted, setIsCompleted] = useState(true);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const completed = isTourCompleted();
    setIsCompleted(completed);
    // Only show tour if not completed
    setIsActive(!completed);
    setIsLoaded(true);
  }, []);

  const nextStep = () => {
    setCurrentStep(prev => prev + 1);
  };

  const prevStep = () => {
    setCurrentStep(prev => Math.max(0, prev - 1));
  };

  const completeTour = () => {
    markTourCompleted();
    setIsCompleted(true);
    setIsActive(false);
    setCurrentStep(0);
  };

  const skipTour = () => {
    completeTour();
  };

  const resetTour = () => {
    // For testing purposes
    localStorage.removeItem('preview_tester_tour_completed');
    setIsCompleted(false);
    setIsActive(true);
    setCurrentStep(0);
  };

  const value = {
    isActive,
    isCompleted,
    currentStep,
    isLoaded,
    nextStep,
    prevStep,
    completeTour,
    skipTour,
    resetTour,
    setCurrentStep,
  };

  return (
    <TourContext.Provider value={value}>
      {children}
    </TourContext.Provider>
  );
};

export default TourProvider;